import { render, staticRenderFns } from "./tablePage2.vue.js?vue&type=template&id=4f32ac8f&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./tablePage2.vue?vue&type=template&id=4f32ac8f&scoped=true"
import script from "./tablePage2.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./tablePage2.vue?vue&type=script&lang=js"
export * from "./tablePage2.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./tablePage2.vue?vue&type=script&lang=js"
import style0 from "./tablePage2.vue.scss?vue&type=style&index=0&id=4f32ac8f&lang=scss&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./tablePage2.vue?vue&type=style&index=0&id=4f32ac8f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f32ac8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f32ac8f')) {
      api.createRecord('4f32ac8f', component.options)
    } else {
      api.reload('4f32ac8f', component.options)
    }
    module.hot.accept("./tablePage2.vue.js?vue&type=template&id=4f32ac8f&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./tablePage2.vue?vue&type=template&id=4f32ac8f&scoped=true", function () {
      api.rerender('4f32ac8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/PageLayout/tablePage2.vue"
export default component.exports